import {
  type Faro,
  getWebInstrumentations,
  initializeFaro,
  TransportItemType,
} from "@grafana/faro-web-sdk";
import { TracingInstrumentation } from "@grafana/faro-web-tracing";

export default defineNuxtPlugin<{
  faro: Faro | undefined;
}>(async (nuxtApp) => {
  const { environment, version, url, name } = nuxtApp.$config.public.faro;

  if (!url) {
    return {
      provide: {
        faro: undefined,
      },
    };
  }

  try {
    const faro = initializeFaro({
      url,
      app: {
        name,
        version,
        environment,
      },
      sessionTracking: {
        // @TODO - WEB Performance - Figure out the correct sampling rate when Faro PROD goes live.
        samplingRate: environment === "production" ? 0.1 : 1,
        // Add defensive configuration to prevent circular references
        persistent: false,
      },
      instrumentations: [
        // Mandatory, omits default instrumentations otherwise.
        ...getWebInstrumentations(),
        // Tracing package to get end-to-end visibility for HTTP requests.
        new TracingInstrumentation({
          instrumentationOptions: {
            propagateTraceHeaderCorsUrls: [
              /^https:\/\/api\.mwsdevv\.com/,
              /^https:\/\/api\.mwsacc\.com/,
              /^https:\/\/api\.matchwornshirt\.com/,
              /^https:\/\/api\.mwsprod\.com/,
            ],
          },
        }),
      ],
      beforeSend: (item) => {
        if (item.type === TransportItemType.EXCEPTION) {
          const itemPayloadContext =
            ("context" in item.payload && item.payload.context) || {};

          item.payload = {
            ...item.payload,
            context: {
              ...itemPayloadContext,
              // Triggered by the framework
              origin: itemPayloadContext.origin || "framework",
            },
          };
        }

        return item;
      },
    });

    return {
      provide: {
        faro,
      },
    };
  } catch {
    // If Faro initialization fails, gracefully degrade
    return {
      provide: {
        faro: undefined,
      },
    };
  }
});
